<template>
  <v-container>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="2500" top>
      {{ snackbar.message }}
    </v-snackbar>

    <v-dialog v-model="composeDialog" max-width="980">
      <v-card>
        <v-card-title class="text-h6">发送邮件</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="composeForm.from"
                :items="sendableMailboxes"
                label="发件邮箱"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="composeForm.to"
                label="收件邮箱"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="composeForm.subject"
                label="主题"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <quill-editor
                v-model="composeForm.body"
                :options="editorOptions"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeCompose">取消</v-btn>
          <v-btn color="primary" :loading="composeSending" :disabled="composeSending" @click="sendMail">发送</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3 style="padding-bottom: 20px;">邮件列表</h3>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title style="display: flex; justify-content: space-between; gap: 12px; flex-wrap: wrap;">
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <v-btn @click="doReadAll">全部已读</v-btn>
              <v-btn color="primary" @click="openCompose" :disabled="sendableMailboxes.length === 0">发送</v-btn>
            </div>
          </v-card-title>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="查找" single-line hide-details></v-text-field>
            <v-btn @click="search_ctri" style="margin-left: 8px;">查找</v-btn>
            <v-btn @click="search_reset" style="margin-left: 8px;">重置</v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="maillist"
            :search="search"
            :loading="loading"
            :server-items-length="totalCnt"
            :options.sync="options"
            :footer-props="{
              itemsPerPageOptions: [50, 100],
              'items-per-page-text': '每页展示',
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-chevron-left',
              nextIcon: 'mdi-chevron-right'
            }"
          >
            <template v-slot:[`item.from_addr`]="{ item }">
              <div :style="{ 'font-weight': getFontWeight(item) }">
                {{ item.from_addr }}
              </div>
            </template>
            <template v-slot:[`item.to_addr`]="{ item }">
              <div :style="{ 'font-weight': getFontWeight(item) }">
                {{ item.to_addr }}
              </div>
            </template>
            <template v-slot:[`item.subject`]="{ item }">
              <div :style="{ 'padding': '3px', 'cursor': 'pointer', 'font-weight': getFontWeight(item) }" @click="subjectClick(item)">
                {{ item.subject }}
              </div>
            </template>
            <template v-slot:[`item.c_time`]="{ item }">
              <div :style="{ 'font-weight': getFontWeight(item) }" @click="subjectClick(item)">
                {{ item.mail_time }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: "vEMailList",

  data: () => ({
    logininfo: {},
    search: '',
    headers: [
      { text: '发件人', value: 'from_addr', width: "180px" },
      { text: '收件人', value: 'to_addr', width: "180px" },
      { text: '内容', value: 'subject' },
      { text: '时间', value: 'c_time', width: "120px" },
    ],
    maillist: [],
    loading: true,
    options: {
      itemsPerPage: 50,
      page: 1,
      sortBy: ['c_time'],
      sortDesc: [true]
    },
    totalCnt: 0,
    timer: null,
    firstload: true,
    composeDialog: false,
    composeSending: false,
    composeForm: {
      from: '',
      to: '',
      subject: '',
      body: ''
    },
    editorOptions: {
      theme: 'snow',
    },
    snackbar: {
      show: false,
      message: '',
      color: 'error'
    }
  }),

  computed: {
    sendableMailboxes() {
      return this.logininfo.sendable_mailboxes || this.logininfo.accessible_mailboxes || [];
    }
  },

  methods: {
    showMessage(message, color = 'success') {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    openCompose() {
      this.composeForm = {
        from: this.sendableMailboxes.length > 0 ? this.sendableMailboxes[0] : '',
        to: '',
        subject: '',
        body: ''
      };
      this.composeDialog = true;
    },

    closeCompose() {
      this.composeDialog = false;
      this.composeSending = false;
    },

    async sendMail() {
      if (!this.composeForm.from) {
        this.showMessage('请选择发件邮箱', 'error');
        return;
      }
      if (!this.composeForm.to || this.composeForm.to.indexOf('@') < 0) {
        this.showMessage('请填写正确的收件邮箱', 'error');
        return;
      }
      this.composeSending = true;
      try {
        axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
        const response = await axios.post('/api/SendMsgEx', {
          from: this.composeForm.from,
          to: this.composeForm.to,
          subject: this.composeForm.subject,
          body: this.composeForm.body
        }, {
          headers: { "Content-Type": "application/json" }
        });
        if (response.status === 200 && response.data.code === 200 && response.data.message === "OK") {
          this.composeDialog = false;
          this.showMessage('邮件已发送，可到发送列表查看备份');
        } else {
          this.showMessage(response.data.message || '发送失败', 'error');
        }
      } catch (error) {
        console.log("sendMail error", error);
        this.showMessage('发送失败', 'error');
      } finally {
        this.composeSending = false;
      }
    },

    subjectClick(item) {
      this.$router.push({ name: "vEmailContent", params: { mailid: item.ref_id } });
    },

    getFontWeight(item) {
      return (item.is_read == 1) ? "normal" : "bold";
    },

    doReadAll: async function () {
      axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
      axios.post('/api/readall').then(
        resp => {
          if (resp.status == 200 && resp.data.code == 200) {
            this.loadData();
          }
        }
      ).catch(
        err => {
          console.log("doReadAll err=>", err);
        }
      );
    },

    search_ctri: async function () {
      if (this.search.length > 2) {
        this.loadData();
      } else {
        this.search = '';
        this.loadData();
      }
    },

    search_reset: async function () {
      this.search = '';
      this.loadData();
    },

    loadData: async function () {
      this.loading = true;
      let pageId = this.options.page;
      let pageNum = this.options.itemsPerPage;
      let condition = '';
      if (this.search != '') condition = "&search=" + this.search;
      axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
      axios.get('/api/emails?page_index=' + pageId + "&page_size=" + pageNum + condition).then(response => {
        this.maillist = [];
        if (response.status == 200 && response.data.code == 200) {
          let mylist = response.data.data || [];
          this.loading = false;
          for (let i in mylist) {
            let citem = {};
            citem.from_addr = mylist[i].from_addr;
            citem.to_addr = mylist[i].to_addr;
            citem.mail_time = mylist[i].mail_time;
            citem.c_time = mylist[i].c_time;
            citem.subject = mylist[i].subject;
            citem.ref_id = mylist[i].ref_id;
            citem.is_read = mylist[i].is_read;
            this.maillist.push(citem);
          }
          this.totalCnt = response.data.total;
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.loading = false;
      });
    }
  },

  created: async function () {
    this.options.page = Number(this.$route.query.page) || 1;
    this.options.itemsPerPage = Number(this.$route.query.per_page) || 50;
    axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
    await axios.get('/api/profile').then(
      response => {
        if (response.status == 200 && response.data.code == 200) {
          this.logininfo = response.data.data;
        } else {
          window.location = '/login';
        }
      }
    )
    .catch(err => {
      window.location = '/login';
      console.log(err);
    });

    await this.loadData();
  },

  watch: {
    options: {
      handler() {
        if (this.firstload) {
          this.firstload = false;
          return;
        }
        this.loadData();
        this.$router.replace({
          query: {
            page: this.options.page,
            per_page: this.options.itemsPerPage,
          }
        });
      },
      deep: true,
    },
    search: {
      handler() {
        let delay = 2000;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.search_ctri();
        }, delay);
      },
      deep: true,
    }
  }
};
</script>
